export interface FeedbackPayload {
  formVersion: 2;
  channel: string;
  fullName: string;
  phone: string;
  city: string;
  visitDate: string;
  customerType: string;
  orderNumber: string;
  purchaseRating: number;
  consultantRating: number;
  foundEverything: string;
  recommendation: string;
  liked: string[];
  comment: string;
  contactPermission: boolean;
  preferredContactMethod: string;
  website: string;
  personalDataConsent: boolean;
  pageUrl: string;
}

interface FeedbackResponse {
  ok?: boolean;
  responseId?: string;
  detail?: string;
  message?: string;
}

const DEFAULT_FEEDBACK_ENDPOINT = "/api/feedback";
const REQUEST_TIMEOUT_MS = 20000;

export const submitFeedback = async (
  payload: FeedbackPayload,
): Promise<FeedbackResponse> => {
  const configuredEndpoint = import.meta.env.VITE_FEEDBACK_API_URL?.trim();
  const endpoint = configuredEndpoint || DEFAULT_FEEDBACK_ENDPOINT;
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    REQUEST_TIMEOUT_MS,
  );

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    const data = (await response
      .json()
      .catch(() => ({}))) as FeedbackResponse;

    if (!response.ok || data.ok === false) {
      throw new Error(
        data.detail || data.message || "Не удалось отправить отзыв.",
      );
    }

    return data;
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new Error(
        "Сервис отзывов не ответил вовремя. Попробуйте ещё раз позже.",
      );
    }

    throw error;
  } finally {
    window.clearTimeout(timeoutId);
  }
};
